import { gql } from '@apollo/client';

export const GET_USER = gql`
  query GetUser {
    user {
      id
      firstName
      lastName
      email
      selectedYear
      role
      userGroupId
      department
      status
      language
      numberFormat
      chatbotExamplesExpanded
      activated
      assistantContext
      createdTimestamp
      lastChangelogSeen
      fullName @client
      isAdmin @client
    }
    company {
      id
      defaultProjectId
      tenantId
      name
      headquarter
      industry {
        id
        name
      }
      subIndustry {
        id
        name
      }
      status
      employeesNum
      companyDomain
      accessScope
      accountType
      shortTermUpperBound
      mediumTermUpperBound
      useNewVersion
      context
      llmMonthlyBudgetEur
      llmBudgetEnforcementEnabled
    }
  }
`;

export const GET_USERS = gql`
  query GetUsers {
    users {
      id
      firstName
      lastName
      email
      role
      status
      language
      userGroupId
    }
  }
`;

export const NUMBER_FORMAT = gql`
  query NumberFormat {
    numberFormat @client
  }
`;

export const GET_INTERNAL_EXTERNAL_USERS = gql`
  query GetInternalExternalUsers {
    internalExternalUsers {
      id
      email
      firstName
      lastName
      role
      isExternal
    }
  }
`;
